// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","fromPreviousLevel":"Card_fromPreviousLevel__EJCcE","red":"Card_red__Um+IQ","black":"Card_black__P1SuH","stack":"Card_stack__iRgos"};